export default "__VITE_ASSET__CNnnk6R7__"